export const convertObjectToArray = (
  value: { [key: string]: unknown },
): unknown[] => Object.keys(value);
